import New from '@admin/components/mjson_designer/entities/page/posts/new'
import ElementToken from '@admin/components/mjson_designer/tokens/element'
import ModalPanel from '@admin/components/modal_panel'
import Search from '@admin/components/search'
import PropTypes from 'prop-types'
import React from 'react'

class Posts extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    device: PropTypes.object,
    website: PropTypes.object,
    onBack: PropTypes.func,
    onNavigate: PropTypes.func,
    onSettings: PropTypes.func
  }

  _handleChoose = this._handleChoose.bind(this)
  _handleNew = this._handleNew.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Search { ...this._getSearch() } />
      </ModalPanel>
    )
  }

  _getProps() {
    const { website } = this.props
    return {
      website,
      onDone: this._handleChoose
    }
  }

  _getPanel() {
    return {
      showHeader: false,
      buttons: [
        { label: 'Create New Post', color: 'blue', handler: this._handleNew }
      ]
    }
  }

  _getSearch() {
    const { team } = this.context.admin
    const { website } = this.props
    return {
      endpoint: `/api/admin/websites/websites/${website.id}/posts`,
      refresh: `/teams/${team.id}/admin/websites/${website.id}/posts`,
      format: (post) => <ElementToken icon="file-text-o" type="post" element={ post } />,
      label: 'Post',
      valueKey: null,
      textKey: 'title',
      onChange: this._handleChoose
    }
  }

  _handleChoose(post) {
    this.props.onSettings(null)
    this.props.onNavigate(`/websites_posts/${post.id}`)
  }

  _handleNew() {
    this.context.modal.open(<New { ...this._getProps() } />)
  }

}

export default Posts
